export class Utils {
    // calls function "myInitCode" when document is ready (even after document is already ready)
    static executeWhenDocumentIsReady(myInitCode) {
        if (typeof myInitCode !== "function") {
            console.error('Provided parameter is not a function');
            return;
        }

        if (document.readyState !== 'loading') {
            myInitCode();
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                myInitCode();
            });
        }
    }
    on(selector, event, handler) {
        document.querySelectorAll(selector).forEach((element) => {
            element.addEventListener(event, handler);
        });
    }
}

export const utils = new Utils();
